import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Switch,TablePagination,
  Tooltip,
  Modal,CircularProgress,FormControl,MenuItem,Select,InputLabel
} from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import CloseIcon from "@mui/icons-material/Close";
import { useSelector } from "react-redux";
import { BASE_URL_TEST } from "../../utils/baseUrl";
import { urls } from "../../urls/urls";
import { useFetch, useDelete, useUpdate } from "../../hooks";

import SnackbarComponent from "../../components/SnackBar/snackBar";



const AdminBrand = () => {
  const [data, setData] = useState([]);
  const [search, setSearch] = useState("");
  const [isModalOpen, setModalOpen] = useState(false);
  const [isEditMode, setEditMode] = useState(false);
  const [brandNameError, setBrandNameError] = useState("");
  const [snackbarState, setSnackbarState] = useState({
    open: false,
    severity: "success", // Default severity  
    message: "",
    position: { vertical: "top", horizontal: "center" },
  });
  const loginToken = useSelector((state) => state.user.logintoken);
  console.log("brnadtoken",loginToken)

  useEffect(() => {
    fetchData();
  }, []);

  
  const {
    data: BrandsData,
    isLoading:isBrandsLoading,
    error,
    fetchData,
  } = useFetch(BASE_URL_TEST + urls("getAllBrands"), {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });
  const {
    data: createBrandsData,
    isLoading: createBrandsLoading,
    error: createBrandsError,
    fetchData: fetchCreateData,
  } = useFetch(BASE_URL_TEST + urls("createBrands"), {
    method: "POST",
    headers: {
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });

  const {
    data: updatedBrandsData,
    isLoading: updatedBrandsLoading,
    error: updatedBrandsError,
    updateData: fetchUpdateData,
  } = useUpdate(BASE_URL_TEST, {
    method: "PUT",
    headers: {
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });

  const {
    data: deletedBrandsData,
    isLoading: deletedBrandsLoading,
    error: deletedBrandsError,
    deleteData: fetchDeleteData,
  } = useDelete(BASE_URL_TEST, {
    method: "DELETE",
    headers: {
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });

  useEffect(() => {
    if (error) {
    } else if (BrandsData && BrandsData["status"] === true) {
      console.log("BrandsData", BrandsData["data"]);
      setData(BrandsData["data"]);
    }
  }, [BrandsData, error]);

  useEffect(() => {
    if (createBrandsError) {
    } else if (createBrandsData && createBrandsData["status"] === true) {
      setSnackbarState({
        ...snackbarState,
        open: true,
        message: createBrandsData["message"],
        position: { vertical: "top", horizontal: "center" },
        severity: "success",
      });
      setModalOpen(false);
      fetchData();
    }
  }, [createBrandsData, createBrandsError]);
  
  useEffect(() => {
    if (updatedBrandsError) {
    } else if (updatedBrandsData && updatedBrandsData["status"] === true) {
      setSnackbarState({
        ...snackbarState,
        open: true,
        message: updatedBrandsData["message"],
        position: { vertical: "top", horizontal: "center" },
        severity: "success",
      });
      setModalOpen(false);
      fetchData();
    }
  }, [updatedBrandsData, updatedBrandsError]);

  useEffect(() => {
    if (deletedBrandsError) {
    } else if (deletedBrandsData && deletedBrandsData["status"] === true) {
      setSnackbarState({
        ...snackbarState,
        open: true,
        message: deletedBrandsData["message"],
        position: { vertical: "top", horizontal: "center" },
        severity: "success",
      });
      setModalOpen(false);
      fetchData();
    }
  }, [deletedBrandsData, deletedBrandsError]);

  const [currentBrand, setCurrentBrand] = useState({
    id: "",
    logo: "",
    brand: "",
    seoUrl: "",
    status: true,
  });
  const [selectedFile, setSelectedFile] = useState(null);
  const [logoPreview, setLogoPreview] = useState(null);
  const [rowsPerPage, setRowsPerPage] = useState(10);
    const [page, setPage] = useState(0);
  // Handle search
  const handleSearch = (event) => {
    setSearch(event.target.value);
  };
  

  // Handle open modal for create
  const handleOpenCreateModal = () => {
    setEditMode(false);
    setCurrentBrand({
      id: "",
      logo: "",
      brand: "",
      seoUrl: "",
      status: true,
    });
    setLogoPreview(null);
    setModalOpen(true);
  };

  // Handle open modal for edit
  const handleOpenEditModal = (brand) => {
    console.log("brand", brand);
    setEditMode(true);
    setCurrentBrand({
      ...brand,
      brand: brand["name"],
      logo: brand["image_url"],
      seoUrl: brand["seo_friendly_url"],
    });
    setLogoPreview(brand.logo);
    setModalOpen(true);
  };

  // Handle save (create or update)
  const handleSave = () => {
    if (isEditMode) {
      console.log("currenBrand", currentBrand);
      console.log("currenData", data);
      console.log("currenData selectedFile", selectedFile);
      const formdata = new FormData();
      formdata.append("name", currentBrand["brand"]);
      // formdata.append("imageurl", selectedFile);
      formdata.append("description", "");
      formdata.append("seo_friendly_url", currentBrand["seoUrl"]);
      formdata.append("status", currentBrand["status"]);

      formdata.append("imageurl", selectedFile ? selectedFile : currentBrand["image_url"] );

      const updateUrl = urls("updateBrands", currentBrand["brand_id"]);
      console.log("updateurl", updateUrl);
      fetchUpdateData(updateUrl, formdata);

      // fetchUpdateData(formdata)
    } else {

      if (!currentBrand["brand"].trim()) {
        setBrandNameError("Brand name is required");
        return;
      }  else {
        const formdata = new FormData();
      formdata.append("name", currentBrand["brand"]);
      formdata.append("description", "");
      formdata.append("seo_friendly_url", "temporarly unavailable");

      formdata.append("imageurl", selectedFile);

      fetchCreateData(formdata);
      }
     

      

    
    }
    setModalOpen(false);
  };

  // Handle delete action
  const handleDelete = (id) => {
    const deleteUrl = urls("deleteBrands", id);

    fetchDeleteData(deleteUrl);
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };


  // Handle file upload
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    console.log("file", file);
    if (file) {
      const reader = new FileReader();
      setCurrentBrand({ ...currentBrand, logo: file["name"] });
      setSelectedFile(file);
      // reader.onload = () => {
      //   setLogoPreview(reader.result); // Display preview
      // };
      // reader.readAsDataURL(file);
    }
  };

  const handleSnackbarClose = () => {
    setSnackbarState((prev) => ({ ...prev, open: false }));
  };

  // Filter data based on search
  const filteredData = search
    ? data.filter(item =>
        item.name.toLowerCase().includes(search.toLowerCase()) ||
        item.description.toLowerCase().includes(search.toLowerCase())
      )
    : data;

  return (
    <Box sx={{ padding: 3, backgroundColor: "#F9FAFC" }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2,
          borderRadius: "20px",
        }}
      >

        <SnackbarComponent
          open={snackbarState.open}
          onClose={handleSnackbarClose}
          severity={snackbarState.severity}
          message={snackbarState.message}
          position={snackbarState.position}
        />
        <TextField
          variant="outlined"
          placeholder="Search"
          size="small"
          value={search}
          onChange={handleSearch}
          sx={{
            width: "30%",
            backgroundColor: "#FFF",
            borderRadius: 1,
          }}
        />
        <Button
          variant="contained"
          startIcon={<AddCircleOutlineIcon />}
          onClick={handleOpenCreateModal}
          sx={{
            backgroundColor: "#28A745",
            "&:hover": { backgroundColor: "#218838" },
            textTransform: "none",
            fontWeight: "bold",
          }}
        >
          Create
        </Button>
      </Box>

       <Box>
                {isBrandsLoading ? (
                  <Box sx={{ display: "flex", justifyContent: "center", mt: 3 }}>
                    <CircularProgress />
                  </Box>
                ) : null}
              </Box>

      <TableContainer
        sx={{
          backgroundColor: "#FFF",
          borderRadius: 2,
          boxShadow: 2,
          borderRadius: "20px",
        }}
      >
        <Table>
          <TableHead sx={{ backgroundColor: "#F5F5F5" }}>
            <TableRow>
              <TableCell sx={{ fontWeight: "bold" }}>BRAND ID</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>LOGO</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>BRAND</TableCell>
              <TableCell sx={{ fontWeight: "bold",display:'none' }}>
                SEO-FRIENDLY URL
              </TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>STATUS</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>ACTION</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
          {filteredData.length > 0 ? (
    filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((item) => (
                <TableRow key={item.brand_id}>
                  <TableCell>{item.brand_id}</TableCell>
                  <TableCell>
                    {item.image_url ? (
                      <Box
                        component="img"
                        src={item.image_url}
                        sx={{
                          width: 40,
                          height: 40,
                          borderRadius: 1,
                          objectFit: "cover",
                        }}
                        alt="Logo"
                      />
                    ) : (
                      <Box
                        sx={{
                          width: 40,
                          height: 40,
                          backgroundColor: "#E0E0E0",
                          borderRadius: 1,
                        }}
                      />
                    )}
                  </TableCell>
                  <TableCell>{item.name}</TableCell>
                  <TableCell sx={{display:'none'}}>{item.seo_friendly_url}</TableCell>
                  <TableCell>
                    {/* <Switch
                      checked={item.status}
                      onChange={() =>
                        setData(
                          data.map((row) =>
                            row.id === item.id
                              ? { ...row, status: !row.status }
                              : row
                          )
                        )
                      }
                      color="success"
                    /> */}

                    <Typography color={item.status===1?'green':'gray'} fontWeight={'bold'}>{item.status===1?'Active':'InActive'}</Typography>
                  </TableCell>
                  <TableCell>
                    <Tooltip title="Edit">
                      <IconButton onClick={() => handleOpenEditModal(item)}>
                        <EditIcon color="primary" />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Delete" sx={{display:'none'}}>
                      <IconButton onClick={() => handleDelete(item.brand_id)}>
                        <DeleteIcon color="error" />
                      </IconButton>
                    </Tooltip>
                  </TableCell>
                </TableRow>
              ))
              ) : (
                <TableRow>
                  <TableCell colSpan={4} style={{ textAlign: 'center' }}>
                    No data found for the searched product.
                  </TableCell>
                </TableRow>
              )}
          </TableBody>
        </Table>
      </TableContainer>

      <TablePagination
                rowsPerPageOptions={[5, 10, 25,50,100]}
                component="div"
                count={data&&data.length?data.length:0}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handlePageChange}
                onRowsPerPageChange={handleRowsPerPageChange}
              />


      {/* Modal for Create/Edit */}
      <Modal open={isModalOpen} onClose={() => setModalOpen(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: { xs: "calc(100vw - 24px)", sm: 400 },
            maxWidth: "100%",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            borderRadius: 2,
          }}
        >
          <IconButton
            sx={{ position: "absolute", top: 8, right: 8 }}
            onClick={() => setModalOpen(false)}
          >
            <CloseIcon />
          </IconButton>
          <Typography variant="h6" mb={2}>
            {isEditMode ? "Edit Brand" : "Create Brand"}
          </Typography>
          <TextField
            fullWidth
            label="Brand"
            variant="outlined"
            value={currentBrand.brand}
            error={!!brandNameError}
                       helperText={
                        brandNameError && (
                                          <Typography
                                            sx={{ textAlign: "left", marginTop: 1, color: "red" }}
                                          >
                                            {brandNameError}
                                          </Typography>
                                        )
                                      }
            onChange={(e) =>
              setCurrentBrand({ ...currentBrand, brand: e.target.value })
            }
            sx={{ mb: 2 }}
          />
          <TextField
            fullWidth
            label="SEO-Friendly URL"
            variant="outlined"
            value={currentBrand.seoUrl}
            onChange={(e) =>
              setCurrentBrand({ ...currentBrand, seoUrl: e.target.value })
            }
            sx={{ mb: 2,display:'none' }}
          />

{isEditMode ? 
                    ( 
                    <FormControl fullWidth sx={{ mb: 5 }}>
                      <InputLabel>Status</InputLabel>
                      <Select
                        value={currentBrand.status || 0} // Default to 0 (Deactive) if status is not set
                        onChange={(e) =>
                          setCurrentBrand((prev) => ({ ...prev, status: e.target.value }))
                        }
                        label="Status"
                      >
                        <MenuItem value={1}>Active</MenuItem>
                        <MenuItem value={0}>Deactive</MenuItem>
                      </Select>
                    </FormControl>):null}


          <Typography>Upload Logo</Typography>
          <input type="file" accept="image/*" onChange={handleFileChange} />
          {currentBrand["logo"] && (
            <Box
              component="img"
              src={currentBrand["logo"]}
              sx={{
                width: 80,
                height: 80,
                borderRadius: 1,
                objectFit: "cover",
                mt: 2,
              }}
              alt="Logo Preview"
            />
          )}
          {/* <Box display="flex" alignItems="center" mt={2}>
            <Typography>Active</Typography>
            <Switch
              checked={currentBrand.status}
              onChange={(e) =>
                setCurrentBrand({
                  ...currentBrand,
                  status: e.target.checked,
                })
              }
              color="success"
            />
          </Box> */}
          <Button
            variant="contained"
            color="primary"
            fullWidth
            onClick={handleSave}
            sx={{ mt: 2 }}
          >
            {isEditMode ? "Update" : "Create"}
          </Button>
        </Box>
      </Modal>
    </Box>
  );
};

export default AdminBrand;
